import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-distributors-main",
    templateUrl: "./distributors.main.component.html",
    standalone: false
})
export class DistributorsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
